import angular, { IController } from 'angular'
import ReactDOM from 'react-dom'
import * as React from 'react'
import { Provider } from 'react-redux'

import { SettingsProvider } from '~/reactapp/App/SettingsContext'
import { PrimaryWebsiteField } from '~/reactapp/App/PrimaryWebsiteField'

function PrimaryWebsiteFieldController(
  this: IController,
  $rootScope,
  $element: JQLite,
  $ngRedux
) {
  this.$postLink = () => {
    ReactDOM.render(
      <Provider store={$ngRedux}>
        <SettingsProvider settings={$rootScope.globalSettings}>
          <PrimaryWebsiteField />
        </SettingsProvider>
      </Provider>,
      $element[0]
    )
  }
}

export default angular
  .module('ellipsis.primaryWebsiteField', [])
  .component('primaryWebsiteField', {
    controller: [
      '$rootScope',
      '$element',
      '$ngRedux',
      PrimaryWebsiteFieldController,
    ],
    template: `<div id="react-PrimaryWebsiteField"/>`,
  })
